import { render, staticRenderFns } from "./PaymentsNotificationModal.vue?vue&type=template&id=2667c4be&"
import script from "./PaymentsNotificationModal.vue?vue&type=script&lang=js&"
export * from "./PaymentsNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports